module.exports = __webpack_public_path__ + "static/cinect-phone-529ccc0ab4a5ef01496840d9705a3635.jpg";